// 非空間データテーブルのオーケストレーション（DuckDB ⇄ データタブ／プロンプト注入の橋渡し）。
//
// 役割: 位置情報を持たない CSV を DuckDB テーブルとして取り込み（loadCsvAsTable）、
//       列・行数・サンプルを集めてデータタブ用のオブジェクトを返す。削除と、エージェントの
//       システムプロンプトへ注入する整形（formatDataTablesForPrompt）も担う。
// 関係: layer-service.js の非空間版。UI（useDataActions / DataPanel）と useAgentSession から使う。
//       formatDataTablesForPrompt は DuckDB 非依存の純関数で node --test で検証する。
import { query } from '../duckdb/db'
import { loadCsvAsTable, dropTable } from '../duckdb/loadFile'

// プレビューに保持するサンプル行数（レイヤー詳細モーダルと揃える）。
const SAMPLE_ROWS = 10

// CSV を非空間データテーブルとして取り込む。
// 戻り値: { tableId, displayName, columns: [{name,type}], rowCount, sample, createdAt }
export async function importCsvDataTable(file, { displayName } = {}) {
  const { name } = await loadCsvAsTable(file)

  const cols = await query(`PRAGMA table_info('${name}');`)
  const columns = cols.map((c) => ({ name: c.name, type: c.type }))

  const [{ cnt }] = await query(`SELECT count(*) AS cnt FROM "${name}";`)
  const sample = await query(`SELECT * FROM "${name}" LIMIT ${SAMPLE_ROWS};`)

  return {
    tableId: name,
    displayName: displayName ?? file.name,
    columns,
    rowCount: Number(cnt),
    sample,
    createdAt: new Date().toISOString(),
  }
}

// データテーブル（DuckDB テーブル）を削除する。
export async function dropDataTable(tableId) {
  await dropTable(tableId)
}

// プロンプト整形は DuckDB 非依存の純関数として data-prompt.js に分離（node --test 用）。
export { formatDataTablesForPrompt } from './data-prompt'
